// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Qfjd3jUl","treeWrapper":"K40mB5ed","readmeWrapper":"YfW_5hgc"};